import BaseGenericRequest from "../BaseGenericRequest";
import {TaskDeleteResponse} from "../TaskDeleteResponse";
import {METHOD} from "co-generic-request";
import {generateRoute} from "../../utils/Router";
import Urls from "../Urls";
import {TaskDeleteMultipleRequest} from "../TaskDeleteMultipleRequest";

export default class TaskDashboardDelete extends BaseGenericRequest<TaskDeleteMultipleRequest, TaskDeleteResponse> {

    private readonly data: TaskDeleteMultipleRequest;

    public constructor(itemIdOrIds: string | string[] ) {
        if (typeof itemIdOrIds === 'string') {
            super(METHOD.METHOD_DELETE, generateRoute(Urls.URL_DASHBOARD_DELETE, {uuid: itemIdOrIds}));
        } else {
            super(METHOD.METHOD_DELETE, generateRoute(Urls.URL_DASHBOARD_DELETE_MULTIPLE));
            this.data = {ids: itemIdOrIds};
        }
    }

    protected getRequest(): TaskDeleteMultipleRequest {
        return this.data;
    }
}